import { history_vehicleService } from '../_services';

const state = { onRequest: false, history_vehicle: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        history_vehicleService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  history_vehicle: state => {
    return state.history_vehicle
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.history_vehicle = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.history_vehicle = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.history_vehicle = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const history_vehicles = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
